<div class="main__inner-wrapper">
<div class="col-md-12 margin-control" *ngIf="leftBannerNode | async as item" [ngClass]="{'terms-of-sale-class': currentPage === 'SeqirusTermsofSale'}">
    <div class="terms_title">{{item.headline}}</div>
    <!-- <div class="terms_heading1" *ngIf="item.uid=='SeqirusuktermsOfConditionscomponent'">{{item.headline}}</div> -->
    <div class="terms_title" *ngIf="item?.subheadline">{{item.subheadline}}</div>
    <div class="header_subtext" *ngIf="item?.paragraphContent" [innerHTML]="item.paragraphContent"></div>
    </div>
  </div>